import { createFileRoute } from '@tanstack/react-router';

import { RequestsPage } from '@/features/admin/RequestsPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/requests')({
  beforeLoad: () => requireRouteAccess('/admin/requests'),
  component: RequestsPage,
});
